import dayjs from 'dayjs';

const fontBold = {
    fontWeight: 'bold',
    borderTop: '1px solid #ccc'
}

const fontRed = {
    color: 'red'
}

const fontGreen = {
    color: 'green'
}

const backTR = {
    backgroundColor: '#cccccc',
}

const subTable = {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '0.85em',
}

const subTh = {
    fontWeight: 'bold',
    borderBottom: '1px solid #ddd',
    padding: '2px 6px',
    textAlign: 'left',
}

const subTd = {
    borderBottom: '1px solid #eee',
    padding: '2px 6px',
    verticalAlign: 'top',
}

const infoDim = {
    fontSize: '0.8em',
    color: '#666',
    wordBreak: 'break-all',
}

const capitalizeStr = (str) => {
    return (str.charAt(0).toUpperCase() + str.slice(1));
}

// Monta a lista estruturada de alterações (campo, antes, depois) para ser
// renderizada em duas colunas na tabela de auditoria.
const getAlteracoes = (tipo, alteracoes) => {
    const rows = [];

    if (!alteracoes) return rows;

    if (tipo == 'Banca' && alteracoes.antigos && alteracoes.antigos.opcoes && alteracoes.novos && alteracoes.novos.opcoes) {
        for (let coluna in alteracoes.antigos.opcoes) {
            if (alteracoes.antigos.opcoes[coluna] != alteracoes.novos.opcoes[coluna])
                rows.push({
                    campo: formatHtml(coluna),
                    antes: formatHtml(alteracoes.antigos.opcoes[coluna]),
                    depois: formatHtml(alteracoes.novos.opcoes[coluna]),
                });
        }
    } else if (tipo == 'Banca' && alteracoes.antigos && alteracoes.antigos.modalidades && alteracoes.novos && alteracoes.novos.modalidades) {
        for (let coluna in alteracoes.antigos.modalidades) {
            if (alteracoes.antigos.modalidades[coluna].descarga != alteracoes.novos.modalidades[coluna].descarga)
                rows.push({
                    campo: alteracoes.novos.modalidades[coluna].nome.replace(/duque\s*-\s*grupo\s*-\s*combinado/gi, "Grupo Combinado"),
                    antes: formatHtml(alteracoes.antigos.modalidades[coluna].descarga),
                    depois: formatHtml(alteracoes.novos.modalidades[coluna].descarga),
                });
        }
    } else if (alteracoes.antigos != null && Object.keys(alteracoes.antigos).length > 0) {
        for (let coluna in alteracoes.antigos) {
            if (alteracoes.antigos[coluna] != (alteracoes.novos ? alteracoes.novos[coluna] : undefined))
                rows.push({
                    campo: formatHtml(coluna),
                    antes: formatHtml(alteracoes.antigos[coluna]),
                    depois: formatHtml(alteracoes.novos ? alteracoes.novos[coluna] : null),
                });
        }
    } else if (alteracoes.novos) {
        for (let coluna in alteracoes.novos) {
            rows.push({
                campo: formatHtml(coluna),
                antes: '—',
                depois: formatHtml(alteracoes.novos[coluna]),
            });
        }
    }

    return rows;
};

// Render das alterações em duas colunas (Antes | Depois).
const Alteracoes = ({ tipo, alteracoes }) => {
    const rows = getAlteracoes(tipo, alteracoes);

    if (rows.length === 0) {
        return <span style={infoDim}>Sem alterações</span>;
    }

    return (
        <table style={subTable}>
            <thead>
                <tr>
                    <th style={subTh}>Campo</th>
                    <th style={subTh}>Antes</th>
                    <th style={subTh}>Depois</th>
                </tr>
            </thead>
            <tbody>
                {rows.map((r, i) => (
                    <tr key={i}>
                        <td style={subTd}>{r.campo}</td>
                        <td style={{ ...subTd, ...fontRed }}>{r.antes}</td>
                        <td style={{ ...subTd, ...fontGreen }}>{r.depois}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

// Render da identificação do dispositivo (dispositivo, IP da internet e fingerprint).
const Dispositivo = ({ coluna }) => {
    const disp = coluna.dispositivo || {};

    return (
        <>
            <div>{disp.resumo || '—'}</div>
            <div style={infoDim}>IP (internet): {coluna.ip || '—'}</div>
            {coluna.device_fingerprint && (
                <div style={infoDim}>Fingerprint: {coluna.device_fingerprint}</div>
            )}
            {coluna.user_agent && (
                <div style={infoDim} title={coluna.user_agent}>Agente: {coluna.user_agent}</div>
            )}
        </>
    );
};

const formatHtml = (html) => {
    return capitalizeStr(String(html)
        .replaceAll('null', 'Vazio')
        .replaceAll('_', ' ')
        .replaceAll('undefined', 'Indefinido')
        .replaceAll('true', 'Ativo')
        .replaceAll('false', 'Desativado')
        .replaceAll('[object Object]', '')
        .replaceAll(/<[^>]*>?/gm, ''));
}

const index = ({relatorio}) => {
    return (
        <>
            <div className="m-t" style={{border: '1px solid #ccc'}}>
                <table className="table">
                    <>
                        <tr style={backTR}>
                            <td style={fontBold}>ID</td>
                            <td style={fontBold}>Usuário</td>
                            <td style={fontBold}>Descrição</td>
                            <td style={fontBold}>Data</td>
                            <td style={fontBold}>Alterações</td>
                            <td style={fontBold}>Dispositivo</td>
                        </tr>
                        <tbody>
                        {relatorio.map((coluna) => {
                            return (
                                <tr key={coluna.id}>
                                    <td>{coluna.id}</td>
                                    <td>{coluna.autor_nome}</td>
                                    <td>{coluna.descricao}</td>
                                    <td>{dayjs(coluna.data).format('DD/MM/YYYY HH:mm:ss')}</td>
                                    <td>
                                        {coluna.auditado_alias && (
                                            <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                                                {coluna.auditado_alias}
                                            </div>
                                        )}
                                        <Alteracoes tipo={coluna.tipo} alteracoes={coluna.alteracoes} />
                                    </td>
                                    <td>
                                        <Dispositivo coluna={coluna} />
                                    </td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </>
                </table>
            </div>
        </>
    );
}


export default index;
